<div class="row mb-1">
  <div class="col-4">
    <label>{{ 'maw.palletCreation.MAWB' | translate }} : {{ mawId }}</label>
    <div>
      <label>Mother Shipper Reference:</label
      ><input
        type="text"
        [(ngModel)]="mawbInvoiceReference"
        [value]="mawbInvoiceReference"
        (blur)="onMotherReference($event)" />
    </div>
  </div>
  <div class="col-3">
    <label class="ml-3">
      {{ 'maw.palletCreation.destinationCountryCode' | translate }} : : {{ ctrycode }}</label
    >
    <div class="ms-3">
      <label>Invoice Number:</label
      ><input
        type="text"
        [(ngModel)]="mawbInvoiceNumber"
        [value]="mawbInvoiceNumber"
        (blur)="onMotherReference($event)" />
    </div>
  </div>
  <div class="col-3">
    <label class="ml-3">
      {{ 'maw.palletCreation.destinationServiceCode' | translate }} : : {{ ctryServiceCode }}</label
    >
  </div>
  <div class="col-1 text-center icon-mat-close">
    <i mat-dialog-close class="bi bi-x"></i>
  </div>
</div>

<div class="row mb-1">
  <div class="col-8">
    <app-charges
      [additionalCharges]="additionalCharges"
      [invoiceReference]="invoiceReference"
      [mawb]="mawId"
      [isClosed]="!isMawOpened"
      *ngIf="hasChargesConfig"></app-charges>

    <!--
    <addtional-charges
      [setData]="additionalCharges"
      [mawb]="mawId"
      [isClosed]="!isMawOpened"
      *ngIf="hasChargesConfig"></addtional-charges>
      -->
  </div>
  <div class="col-4 text-end">
    <button class="primary-btn" *ngIf="isMawOpened" (click)="createPallet()">
      {{ 'maw.palletCreation.addPallet' | translate }}
    </button>
  </div>
</div>

<div class="custom-card">
  <div class="col-12 table-container">
    <table
      aria-describedby="palletlist"
      mat-table
      [dataSource]="dataSource"
      matSort
      class="tabletop">
      <ng-container matColumnDef="palletID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'maw.palletCreation.palletID' | translate }}
        </th>
        <td mat-cell *matCellDef="let element" (click)="NavToPalletDetail(element)" class="td-link">
          {{ element.palletID }}
        </td>
      </ng-container>

      <ng-container matColumnDef="totalLinkedPieces">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'maw.palletCreation.totalLinkedPieces' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="total-pieces">
            {{ element?.totalLinkedPieces }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="packagingType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'maw.palletCreation.packagingType' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <div style="font-size: 12px">
            <mat-form-field appearance="none">
              <div class="package-type">
                <mat-select
                  [disabled]="element.closed"
                  placeholder="{{ 'maw.palletCreation.selectTypes' | translate }}"
                  (selectionChange)="changePackageType($event, element?.palletID)"
                  class="align-dropdown form-control"
                  [(ngModel)]="element.packageTypes"
                  [value]="element?.packageTypes">
                  <mat-option *ngFor="let type of packageTypes" [value]="type">
                    {{ type.packagingType }}</mat-option
                  >
                </mat-select>
              </div>
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="length">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'maw.palletCreation.length' | translate }} {{ 'maw.palletCreation.CM' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <input
            [disabled]="element.closed"
            class="text-center input-inside-header form-control"
            type="number"
            min="0"
            [ngClass]="!checkValidation(element?.dimensions?.length) ? 'border-color' : ''"
            [(ngModel)]="element.dimensions.length"
            [value]="element?.dimensions?.length" />
        </td>
      </ng-container>

      <ng-container matColumnDef="width">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'maw.palletCreation.width' | translate }} {{ 'maw.palletCreation.CM' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <input
            [disabled]="element.closed"
            class="text-center input-inside-header form-control"
            type="number"
            min="0"
            [ngClass]="!checkValidation(element?.dimensions?.width) ? 'border-color' : ''"
            [(ngModel)]="element.dimensions.width"
            [value]="element?.dimensions?.width" />
        </td>
      </ng-container>

      <ng-container matColumnDef="height">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'maw.palletCreation.height' | translate }} {{ 'maw.palletCreation.CM' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <input
            [disabled]="element.closed"
            class="text-center input-inside-header form-control"
            type="number"
            min="0"
            [ngClass]="!checkValidation(element?.dimensions?.height) ? 'border-color' : ''"
            [(ngModel)]="element.dimensions.height"
            [value]="element?.dimensions?.height" />
        </td>
      </ng-container>

      <ng-container matColumnDef="weight">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'maw.palletCreation.weight' | translate }} {{ 'maw.palletCreation.KG' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <input
            [disabled]="element.closed"
            class="text-center input-inside-header form-control"
            type="number"
            min="0"
            [ngClass]="!checkValidation(element?.weight) ? 'border-color' : ''"
            [(ngModel)]="element.weight"
            [value]="element?.weight" />
        </td>
      </ng-container>

      <ng-container matColumnDef="closed">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'maw.palletCreation.status' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.closed">{{ 'maw.palletCreation.closed' | translate }}</span>
          <span *ngIf="!element.closed">{{ 'maw.palletCreation.open' | translate }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="Action">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'maw.palletCreation.action' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <span
            [matTooltip]="
              closeDisabled(element?.palletID)
                ? ('maw.palletCreation.close' | translate)
                : ('maw.palletCreation.enterValidDimensions' | translate)
            "
            [ngClass]="closeDisabled(element?.palletID) ? 'icon-mat' : 'disable-icon-mat'"
            *ngIf="!element.closed"
            class="me-2 pe-2"
            (click)="closurePallet(element)">
            <i class="bi bi-folder-x"></i>
          </span>

          <span
            matTooltip="{{ 'maw.palletCreation.reOpen' | translate }}"
            *ngIf="element.closed && isMawOpened"
            class="me-2 pe-2 icon-mat"
            (click)="managePallet('REOPEN', element.palletID)">
            <i class="bi bi-folder-check"></i>
          </span>

          <span
            *ngIf="isMawOpened"
            class="me-2 pe-2 icon-mat"
            matTooltip="{{ 'maw.palletCreation.delete' | translate }}"
            (click)="deletePallet('REMOVE', element.palletID)">
            <i class="bi bi-trash"></i>
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row justify-content-center" *matNoDataRow>
        {{
          'maw.palletCreation.noDataAvailable' | translate
        }}
      </tr>
    </table>
    <mat-paginator [pageSizeOptions]="[15, 30, 45]" showFirstLastButtons></mat-paginator>
  </div>
</div>
